export const AVAILABLE_DELIVERY_TYPES = ['home', 'relayPoint', 'bioculture', 'organization'];
